import { ConsumableQuantityEstimationThemeModeConfig } from './types';

const light: ConsumableQuantityEstimationThemeModeConfig = {
  consumableQuantityEstimation: {},
};

export default light;
